import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const orderNumber = params.get("n");
  return (
    <div className="pt-32 min-h-[80vh] flex items-center justify-center px-6 text-center" data-testid="order-success-page">
      <div>
        <CheckCircle2 className="mx-auto text-[var(--hk-orange)]" size={64} />
        <h1 className="mt-8 font-display text-5xl md:text-7xl font-bold uppercase tracking-tighter">
          Order <span className="italic text-[var(--hk-purple-text)]">locked in</span>
        </h1>
        {orderNumber && (
          <p className="mt-4 text-gray-300">
            Order # <span className="font-mono-alt tracking-widest text-[var(--hk-orange)]">{orderNumber}</span>
          </p>
        )}
        <p className="mt-3 text-gray-400 max-w-md mx-auto">
          We&apos;ll text you shortly to confirm timing. Have your cash ready when we arrive.
        </p>
        <Link
          to="/"
          data-testid="order-success-home-btn"
          className="mt-8 inline-block bg-[var(--hk-orange)] text-black font-display font-bold uppercase tracking-wider px-8 py-4 rounded-sm hover:bg-[var(--hk-orange-hover)] transition-colors"
        >
          Back home
        </Link>
      </div>
    </div>
  );
}
